declare global {
  namespace JSX {
    interface IntrinsicElements {
      'elevenlabs-convai': React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement> & { 'agent-id': string },
        HTMLElement
      >;
    }
  }
}

export default function VoiceBot() {
  return (
    <elevenlabs-convai agent-id="agent_4901kp7r15wmfjctr6r9pcheza05" />
  );
}
